import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import EnergyReplaceBlockData from "../../../Models/Content/EnergyReplaceBlockData";
import EnergyReplace from "./EnergyReplace";

export default class EnergyReplaceBlock extends EpiComponent<EnergyReplaceBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["energy-replace-block"];
    // if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    // if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <EnergyReplace iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
